var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var History = ReactRouter.History;
var Shopify = require('./shopify');
var Breadcrumb = require('./breadcrumb');
var ProductRow = require('./product-row');
var Craftmanship = require('./image-on-left');
var ScrollToTop = require('./scroll-to-top');
var ScreenWid = require('./stores/screen-wid-store');

module.exports = React.createClass({
	
  mixins: [ History, ScrollToTop ],

  product: {},
  collection: [],
  touchStartY: 0,
  unmounted: false,

  getInitialState: function() {
  	return { gender: "",
             price: "",
             priceOrg: null,
             prodColor: "",
             prodMatl: "",
  	         collTitle: "",
             collUrl: "",
             description: "",
  	         prodName: "",
             sizes: [],
             widthes: [],
             craft_img: "",
             craft_prefix: "",
             craft_title: "",
             craft_desc: "" }
  },

  componentDidMount: function() {
    var shareUrl = window.location.href;
    var options = {
        twitter: {
          text: 'Check out Ingledews online store! ',
          via: 'ingledews'
        },
        facebook : true,
        googlePlus : true, 

        // Pinterest requires a image to be "pinned"
        pinterest: {
          media: 'http://example.com/image.jpg',
          description: 'My ingledews shoes'
        },

        // Tumblr takes a name and a description
        tumblr: {
          name: 'Ingledews store',
          description: 'Ingledews online store! Check out!'
        }
    };  

    Shopify.getSingleProduct(this.props.params.prodHandle, this.productInfoGot);
    this.scrollToTop('product-detail-page');
    jQuery('.social-share').shareButtons(shareUrl, options);
/*
    if (jQuery(window).width() >= 768) {

      jQuery(window).scroll(function(){ // scroll event
 
        jQuery(ReactDOM.findDOMNode(this.refs.prodInfoWrapper))
            .height(jQuery('.img-wrapper').height());
        var windowTop = jQuery(window).scrollTop(); // returns number 
        var stickyBottom = jQuery('.nav').outerHeight(true) +
                           jQuery('.img-wrapper').outerHeight(true) -
                           jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).outerHeight(true);
        
        if (windowTop < stickyBottom) {
          jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).addClass('affix');
          jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).removeClass('affix-top');
          jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).removeClass('affix-bottom');
        } else {
          jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).addClass('affix-bottom');
          jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).removeClass('affix');
          jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).removeClass('affix-top');
        }
 
      }.bind(this));


      jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).affix({
        offset: {
          top: 1, //add a smallest number to prevent content below from jumpy
          bottom: function () {
            
            return (this.bottom = jQuery('footer').outerHeight(true) +
                                  jQuery(ReactDOM.findDOMNode(this.refs.craftmanship)).outerHeight(true) +
                                  jQuery('#related-product').outerHeight(true) + 200)
          }.bind(this)
        }
      });

    }
*/

    var setInfoDivWidth = function() {
      var windowWidth = jQuery(window).width();
      if (windowWidth >= 1200) {
        jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).width(555);
      } else if (windowWidth >= 992) {
        jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).width(455);
      } else {
        jQuery(ReactDOM.findDOMNode(this.refs.divProdInfo)).width(windowWidth / 2 - 30);
      }
    }.bind(this);
/*
    jQuery("#prod-info").on('affixed.bs.affix', function(){
      setInfoDivWidth();
    });

    jQuery(window).on("resize", function() {
      setInfoDivWidth();
    });
*/
  },

  componentWillUnmount: function() {
    this.unmounted = true;
  },

  productInfoGot: function(product) {
    if (this.unmounted) return;

    document.title = product.title + " - Ingledew's Shoes";

    product.variants = product.variants.filter(function(v) {
      return v.inventory_quantity > 0;
    });
    this.product = product;
    var gender = product.tags.indexOf('Womens') >= 0 ? "womens" : "mens";

    var craftmanshipList = CMS.productDet[gender];

    craftmanshipList = _.filter(craftmanshipList, function(c) {
                           return c.active == "true";
                       });
    if (craftmanshipList.length) {
      var c_index = Math.floor(Math.random() * craftmanshipList.length);
      var craftmanshipData = craftmanshipList[c_index];

      this.setState({craft_img: craftmanshipData.img,
                     craft_prefix: craftmanshipData.prefix,
                     craft_title: craftmanshipData.title,
                     craft_desc: craftmanshipData.desc});
    }
    this.refs.breadcrumb.setGender(gender);
  	this.refs.breadcrumb.setThirdSeg(product.title);
    var uniqueSizes = _.reduce(product.variants, function(acc, v) {
      if (v.inventory_quantity > 0 && acc.indexOf(v.option2) < 0) {
        acc.push(v.option2);
      }
      return acc;
    }, []);

    var i = 0;
    uniqueSizes = _.sortBy(uniqueSizes, function(size) {
                      if (size.substring(size.length - 1) == '-'){
                        var strValue = size.substring(0, size.length - 1);
                        return parseInt(strValue) + 0.5;
                      } else {
                        return parseInt(size);
                      }
                  });
    var sizes = uniqueSizes.map(function(s) {
        i++;
        var key = s + i;
        return <option name={s} value={s} key={key}>{s}</option>
    }.bind(this));

    var uniqueWidthes = _.reduce(product.variants, function(result, variant) {
      if (result.indexOf(variant.option3) < 0) result.push(variant.option3);
      return result;
    }, []);
    i = 0;
    var widthes = uniqueWidthes.map(function(width) {
      i++;
      return <option name={width} value={width} key={width + i}>{width}</option>
    }.bind(this));

    var prodDesc = product.body_html.split('</p>');
    var desc1 = prodDesc[0].replace('<p>', '');
    var desc2 = prodDesc[1] ? jQuery('<p>').html(prodDesc[1].replace('<p>', '')) : "";
    var prodColor = product.variants[0].option1.split(' ')[0];
    //var prodMatl = product.variants[0].option1.split(' ')[1];
    var prodTags = product.tags.split(',').map(function(w) { return w.trim().toUpperCase(); });
    var prodMatl = _.reduce(prodTags, function(acc, tag) {
                                          if (acc.length) return acc;
                                          else {
                                            if (CMS.misc.matl_words.toUpperCase().indexOf(tag) >= 0) {
                                              acc = tag;
                                            }
                                            return acc;
                                          }
                                      }, '');
    var priceOrg = product.variants.length > 0 ? product.variants[0].compare_at_price : product.compare_at_price;
    var price = "$" + (product.variants.length > 0 ? product.variants[0].price : product.price);

    if (priceOrg > 0) {
      priceOrg = "$" + priceOrg;
      price = " SALE: " + price;
      jQuery(ReactDOM.findDOMNode(this.refs.price)).addClass('sale-price');
    } else {
      priceOrg = null;
    }
    this.setState({ prodName: product.title,
                    prodBrand: product.vendor,
                    prodColor: prodColor,
                    prodMatl: prodMatl,
                    price: price,
                    priceOrg: priceOrg,
                    description: desc1,
                    description2: desc2,
                    prodImages: this.createImages(product.images),
                    sizes: sizes,
                    widthes: widthes,
                    gender: gender });
    jQuery(this.refs.forAppend).append(desc2);
    jQuery(this.refs.btnAddToBag).prop('disabled', false);
    var collection = "";
    var colls = { "DRESS": "dress-shoes",
                  "CASUAL": "casual-shoes",
                  "BOOTS": "boots",
                  "SANDALS": "sandals",
                  "LEATHER": "handbags",
                  "ACCESSORIES": "accessories",
                  "SOCKS-MEN": "accessories",
                  "WALLET": "accessories",
                  "BELTS MEN": "accessories",
                  "SPORT": "specialty-shoes",
                  "HEALTH": "specialty-shoes" };

    for (var key in colls) {
      if (product.product_type.indexOf(key) >= 0) {
        collection = colls[key];
      }
    }
    if (collection) {
      if (collection != "accessories") {
        if (product.tags.indexOf("Womens") >=0 || product.tags.indexOf("womens") >=0) {
          collection += "-womens";
        } else {
          collection += "-mens";
        }
      }
      Shopify.getCollectionInfo(collection, this.collectionInfoGot);
      Shopify.getCollection(collection, this.collectionGot);
    }
    
    var options = {
        selector: '.img-wrapper img',
        animation: 'slide',
        slideshowSpeed: 5000,
        directionNav: false,
        animationLoop: true
     }
    if("SM" !== ScreenWid.width) {
        options.direction = "vertical";
    }
    jQuery('.slides').flexslider(options);
  },

  setViewportHeight: function(e){
    if("SM" !== ScreenWid.width) {
        jQuery('.flex-viewport').height(e.target.clientHeight); 
    }
  },
  
  createImages: function(images) {
    var first= true;
    
    var imgs = images.map(function(image) {
        if (first) {
            first = false;
            return <img src={image.src} onLoad ={this.setViewportHeight}></img> 
        } else {
            return <img src={image.src} ></img>
        }
    }.bind(this));
    if (0 == imgs.length) {
      return <img src={ImageUrl.dummyShoe}></img>
    } else {
      return imgs;
    }
  },

  collectionInfoGot: function(collectionInfo) {
    if (this.unmounted) return;

    var collUrl = "/collections/" + collectionInfo.handle + "/" + this.state.gender;
    this.refs.breadcrumb.setSecondSeg({ url: collUrl,
                                        text: collectionInfo.title } );
    this.setState({ collTitle: collectionInfo.title,
                    collUrl: collUrl });
  },

  collectionGot: function(coll) {
    if (this.unmounted) return;

    this.collection = coll;
    if (this.product.title) {
      var p3 = _.take(_.filter(this.collection, function(p) {
        return p.handle != this.product.handle;
      }.bind(this)), 3);
      this.refs.productRow.setProducts(p3);
    }
  },

  handleSizeChange: function(e) {
    var target = e.target;
    var uniqueWidthes = _.reduce(this.product.variants, function(result, variant) {
      if (variant.inventory_quantity > 0 && result.indexOf(variant.option3) < 0 &&
          variant.option2 == target.value) {
        result.push(variant.option3);
      }
      return result;
    }, []);
    var i = 0;
    var widthes = uniqueWidthes.map(function(width) {
      i++;
      return <option name={width} value={width} key={width + i}>{width}</option>
    }.bind(this));

    this.setState({ widthes: widthes });

    jQuery(this.refs.sizeAndWidthPrompt).css('display', 'none');
  },

  handleWidthChange: function(e) {
    var target = e.target;
    var uniqueSizes = _.reduce(this.product.variants, function(acc, v) {
      if (v.inventory_quantity > 0 &&acc.indexOf(v.option2) < 0 &&
          v.option3 == target.value) {
        acc.push(v.option2);
      }
      return acc;
    }, []);
    var i = 0;
    uniqueSizes = _.sortBy(uniqueSizes, function(size) {
                      if (size.substring(size.length - 1) == '-') {
                        var strValue = size.substring(0, size.length - 1);
                        return parseInt(strValue) + 0.5;
                      } else {
                        return parseInt(size);
                      }
                  });
    var sizes = uniqueSizes.map(function(s) {
        i++;
        var key = s + i;
        return <option name={s} value={s} key={key}>{s}</option>
    }.bind(this));
    this.setState({ sizes: sizes });

    jQuery(this.refs.sizeAndWidthPrompt).css('display', 'none');
  },

  handleAddToBag: function() {
    var size = "";
    var sizeIndex = this.refs.size.selectedIndex;
    if (sizeIndex > 0) {
      size = jQuery(this.refs.size).val();
    } else {
      jQuery(this.refs.sizeAndWidthPrompt).css('display', 'block');
      return;
    }
    var width = "";
    var widthIndex = this.refs.width.selectedIndex;
    if (widthIndex > 0) {
      width = jQuery(this.refs.width).val();
    } else {
      jQuery(this.refs.sizeAndWidthPrompt).css('display', 'block');
      return;
    }
    var variantId = _.reduce(this.product.variants, function(result, v) {
      if (v.option2 == size && v.option3 == width) {
        result = v.id;
        return result;
      } else {
        return result;
      }
    }, this.product.variants[0].id);

    this.props.addToBag(variantId);
  },

  goBack: function() {
    this.history.goBack();
  },

  render: function() {
    var pathName = this.props.location.pathname;

    return <div>
        <Breadcrumb ref="breadcrumb" className="hidden-xs" gender={this.state.gender} />
        <div className={"container breadcrumb-m visible-xs-block"}>
            <Link to={this.state.collUrl}>
                {"< BACK TO " + this.state.collTitle}
            </Link>
        </div>
        {this.props.prevRoute.length ? <div className="container back-link"><a onClick={this.goBack}>&laquo;&nbsp;BACK</a></div> : null }
        <main id="content" role="main">
            <section className="container" id="prod-detail">
                <div className="row scroll-container">
                    <div className="col-sm-6 slides-container" >
                        <div className="slides">
                            <div className="img-wrapper" ref="imgWrap">
                                {this.state.prodImages}
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6" ref="prodInfoWrapper">
                        <div id="prod-info" ref="divProdInfo">
                            <h1>{this.state.prodName}</h1>
                            <p id="brand">{this.state.prodBrand}</p>
                            <p>
                                <span id="org-price">{this.state.priceOrg}</span>
                                <span id="price" ref="price">{this.state.price}</span>
                            </p>
                            <p>{this.state.description}</p>
                            <p id="color-material">{this.state.prodColor} | {this.state.prodMatl}</p>
                            <div className="row">
                                <div className="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3">
                                    <div className="styled-select">
                                        <div className="select-default">SELECT SIZE</div>
                                        <select ref="size" onChange={this.handleSizeChange}>
                                            <option value="" disabled>SELECT SIZES</option>
                                            {this.state.sizes}
                                        </select>
                                    </div>
                                    <div className="styled-select">
                                        <div className="select-default">SELECT WIDTH</div>
                                        <select ref="width" onChange={this.handleWidthChange}>
                                            <option value="" disabled>SELECT WIDTH</option>
                                            {this.state.widthes}
                                        </select>
                                    </div>
                                    <p ref="sizeAndWidthPrompt" id="size-width-prompt" className="error">Please select size and width</p>
                                    <p ref="btnAddToBag" className="btn btn-primary btn-full"
                                       onClick={this.handleAddToBag}>ADD TO BAG</p>
                                </div>
                            </div>
                            <div  ref="forAppend"></div>
                            <nav id="in-prod-nav">
                                <Link to="/pages/stores">FIND A STORE</Link>
                                <span>&#8226;</span>
                                <Link to="/pages/shipping-returns">SHIPPING & RETURNS</Link>
                                <span>&#8226;</span>
                                <Link to="#" className="social-share">SHARE</Link>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <div className="hidden-xs" ref="craftmanship">
                <Craftmanship image={this.state.craft_img} prefix={this.state.craft_prefix}
                              title={this.state.craft_title} text={this.state.craft_desc} />
            </div>
            <section id="related-product" className="container hidden-xs">
                <p className="lead">- keep shopping -</p>
                <h1>May we suggest</h1>
                <ProductRow ref="productRow" collection={this.props.params.coll} />
            </section>
        </main>
      </div>
  }
});